import { useState } from 'react';
import { createContainer } from 'unstated-next';

// 列表相关的状态
const useListStore = (
    initialState = {
        id: '',
        party: 0,
        highlights: 0,
        order: '',
        page: 1,
        size: 20,
        parties: [],
        total: 0,
        nodes: [],
        allowComment: false,
        title: '',
        summary: '',
        shareImgUrl: '',
        finish: 0,
        follow: false,
        // 全部展开状态
        allFold: false,
        // nav高度
        navHeight: 0,
        interactionRsp: null,
        pcBgInfo: null,
        // http状态
        online: true,
        liveList: [],
        liveInfo: null,
    },
) => {
    const [listStates, setListStates] = useState(initialState);

    const changeListStates = newListStates => {
        setListStates(prevStates => {
            return Object.assign({}, prevStates, newListStates);
        });
    };

    return { listStates, changeListStates };
};

export const ListStore = createContainer(useListStore);

// 总列表状态
const useStore = (
    initialState = {
        // 总列表
        nodes: [],
    },
) => {
    const [states, setStates] = useState(initialState);

    const changeStates = newStates => {
        setStates(states => Object.assign({}, states, newStates));
    };

    return { states, changeStates };
};

export const Store = createContainer(useStore);
